"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

// Place a node at a location.
exports.default = function placeAtLoc(newNode, loc) {
  return Object.assign(newNode, loc);
};